export default __webpack_public_path__ + "static/media/swap-fees.e21e8018.png";